import Extend from 'flarum/common/extenders';
import ContactPage from './components/ContactPage';
export default [new Extend.Routes().add('ubuntuhu.map', '/map', ContactPage)];